<template>
  <div>
    <div class="barcode-generator" id="non-printable">
      <!-- Toolbar -->
      <v-toolbar flat fixed class="generator-toolbar">
        <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
        <v-toolbar-title class="white--text">{{ $t('barcode.generator.title') }}</v-toolbar-title>
        <!-- <v-spacer></v-spacer>
        <v-btn icon @click="fn_preview" :disabled="!canPrint" :title="$t('barcode.generator.preview')">
          <v-icon>visibility</v-icon>
        </v-btn> -->

        <!-- <v-btn @click="fn_print('usb')">{{ $t('barcode.generator.printUsb') }}</v-btn> -->

        <!-- <v-menu offset-y>
          <v-btn color="primary" flat slot="activator">{{ $root.labelPrintLanguage }}</v-btn>
          <v-list>
            <v-list-tile @click="$root.labelPrintLanguage = 'shreyans'">
              <v-list-tile-title>Shreyans</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$root.labelPrintLanguage = 'tspl'">
              <v-list-tile-title>TSPL</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$root.labelPrintLanguage = 'epl'">
              <v-list-tile-title>EPL</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$root.labelPrintLanguage = 'zpl'">
              <v-list-tile-title>ZPL</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$root.labelPrintLanguage = 'dpl'">
              <v-list-tile-title>DPL</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$root.labelPrintLanguage = null">
              <v-list-tile-title>None</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu> -->
      </v-toolbar>

      <div class="generator-body hasToolbar">
        <v-alert type="info" icon="info_outline" class="pr-0" :value="true" @click="$router.push('/settings/business/labelprintsettings')">
          <span light-opacity-color>{{ $t('barcode.generator.printerLanguage') }}:</span> {{ $root.LabelPrintSettings && $root.LabelPrintSettings.printLanguage ? $root.LabelPrintSettings.printLanguage.toUpperCase() : 'TSPL' }}<br><span light-opacity-color>{{ $t('barcode.generator.connection') }}:</span> {{ $root.LabelPrintSettings && $root.LabelPrintSettings.printerConnectionType == 'usb' ? 'USB'  : 'Bluetooth' }}
          <!-- <v-icon font16>{{$root.LabelPrintSettings && $root.LabelPrintSettings.printerConnectionType == 'usb' ? 'usb'  : 'blue'}}</v-icon> -->
          <v-spacer></v-spacer>
          <span class="primary-color">{{ $t('barcode.generator.changeSettings') }} <v-icon font16 class="primary-color">chevron_right</v-icon></span>
        </v-alert>
        <!-- 3/4/7 — run-level settings. One paper size per run, so the sheet
             grid stays uniform and every label matches the chosen template. -->
        <v-card flat class="mb-2">
          <!-- <v-card-title class="pb-1"><v-icon left>settings</v-icon>{{ $t('barcode.generator.labelSettings') }}</v-card-title> -->
          <!-- <v-divider></v-divider> -->
          <v-card-text>
            <v-layout row wrap>
              <!-- <v-flex xs12 sm6 md6 mb-3>
                <v-select
                  v-model="selectedPaperSize"
                  :items="paperSizes"
                  :label="$t('barcode.generator.paperSize')"
                  @change="fn_onPaperSizeChange"
                  dense outlined hide-details
                ></v-select>
              </v-flex> -->

              <!-- 7 — printer selection -->
              <!-- <v-radio-group v-model="printerType" row hide-details class="mb-3" @change="fn_fetchTemplates">
                <v-radio :label="$t('barcode.generator.labelPrinter')" value="Label"></v-radio>
                <v-radio :label="$t('barcode.generator.regularPrinter')" value="Regular"></v-radio>
              </v-radio-group> -->

              <v-flex xs12 sm6 md6 mb-3>
                <v-select
                  v-model="Form.selectedTemplateId"
                  :items="filteredTemplates"
                  item-text="labelName"
                  item-value="barcodeTemplateId"
                  :label="$t('barcode.generator.selectTemplate')"
                  placeholder=" "
                  :no-data-text="templatesLoading ? 'Loading…' : 'No saved templates for this paper size'"
                  @change="fn_onTemplateChange"
                  dense outlined hide-details
                ></v-select>
              </v-flex>
            </v-layout>

            <div v-if="Form.selectedTemplate" class="template-meta mt-3">
              {{ $t('barcode.generator.templateLabel') }} {{ Form.selectedTemplate.width }} × {{ Form.selectedTemplate.height }} mm
              · {{ Form.selectedTemplate.fields.length }} {{ $t('barcode.generator.fieldsCount') }}
            </div>
            <!-- <div v-else-if="!templatesLoading" class="template-meta template-meta-warn mt-3">
              No template saved for {{ selectedPaperSize }} yet — design one first.
            </div> -->
          </v-card-text>
        </v-card>

        <!-- 1/2/6 — per-item entry -->
        <v-card flat class="mb-2">
          <!-- <v-card-title class="pb-1"><v-icon left>add_box</v-icon>{{ $t('barcode.generator.addItem') }}</v-card-title> -->
          <!-- <v-subheader>{{ $t('barcode.generator.addItem') }}</v-subheader>
          <v-divider></v-divider> -->
          <v-card-text>
            <v-layout row wrap>
              <!-- 1 — item picker (same dialog the rest of the app uses) -->
              <v-flex xs12 sm12 md12 align-msg-right @click="fn_openProductsDialog">
                <v-text-field
                  readonly
                  v-model="Form.itemName"
                  :label="$t('barcode.generator.item')"
                  placeholder=" "
                  append-icon="arrow_drop_down"
                  :onUpdate="fn_updateProduct"
                  ref="ref_fieldProductName"
                ></v-text-field>
              </v-flex>

              <!-- 2 — item code, filled from the product, never typed -->
              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="product_code"
                  v-model="Form.productCode"
                  :label="$t('barcode.generator.itemCode')"
                  placeholder=" "
                ></v-text-field>
              </v-flex>

              <!-- 6 — labels for this item -->
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model.number="Form.qty"
                  :label="$t('barcode.generator.noOfLabels')"
                  placeholder=" "
                  type="number"
                  min="1"
                ></v-text-field>
              </v-flex>

              <!-- Prompt fields (Date / Input Text) defined in this template.
                   Blank is allowed — a blank one is simply hidden on the label. -->
              <v-flex xs12 sm6 md6 v-for="pf in promptFields" :key="pf.promptId">
                <!-- Date -> picker -->
                <v-menu
                  v-if="pf.inputType === 'date'"
                  v-model="promptMenus[pf.promptId]"
                  :close-on-content-click="false"
                  full-width
                  min-width="290px"
                  transition="scale-transition"
                >
                  <v-text-field
                    slot="activator"
                    :value="fn_formatDate(Form.promptValues[pf.promptId])"
                    :label="pf.promptLabel"
                    :placeholder="$t('barcode.generator.selectDate')"
                    append-icon="event"
                    readonly
                    clearable
                    @click:clear="fn_setPromptValue(pf.promptId, '')"
                  ></v-text-field>
                  <v-date-picker
                    :value="Form.promptValues[pf.promptId]"
                    @input="fn_onPromptDate(pf.promptId, $event)"
                  ></v-date-picker>
                </v-menu>

                <!-- Input Text -> single-line text -->
                <v-text-field
                  v-else
                  :value="Form.promptValues[pf.promptId]"
                  :label="pf.promptLabel"
                  placeholder=" "
                  @input="fn_setPromptValue(pf.promptId, $event)"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-btn
              color="primary"
              block
              :disabled="!canAddItem"
              @click="fn_addItem"
            >
              <v-icon style="color:#ffffff !important;margin-right: 10px;">add</v-icon>{{ $t('barcode.generator.addToList') }}
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- 5 — the print list -->
        <v-card flat v-if="Form.items && Form.items.length">
          <!-- <v-card-title class="pb-1">
            Items ({{ items.length }})
            <v-spacer></v-spacer>
            <span class="total-labels" v-if="items.length">{{ totalLabels }} label(s)</span>
          </v-card-title> -->
          <v-subheader>{{ $t('barcode.generator.items') }}: {{ Form.items.length }}
            <v-spacer></v-spacer>
            <span class="total-labels" v-if="Form.items.length">{{ totalLabels }} {{ totalLabels.length == 1 ? $t('barcode.generator.label') : $t('barcode.generator.labels') }}</span>
          </v-subheader>
          <v-divider></v-divider>

          <div v-if="!Form.items.length" class="no-items">{{ $t('barcode.generator.noItemsAdded') }}</div>

          <v-list two-line v-else>
            <template v-for="(row, index) in Form.items">
              <v-list-tile :key="'row-' + index" data-no-translate>
                <v-list-tile-content>
                  <v-list-tile-title>{{ row.itemName }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t('barcode.generator.code') }}: {{ row.productCode || '—' }} · {{ row.qty }} {{ row.qty == 1 ? $t('barcode.generator.label') : $t('barcode.generator.labels') }}
                  </v-list-tile-sub-title>
                  <!-- <v-list-tile-sub-title>
                    <button @click="row.qty--" :disabled="row.qty===1" style="background-color: #eee;width:24px;height:24px;">-</button> 
                      <input type="number" v-model.number="row.qty" min="1" style="width: 32px; text-align: center;"> 
                    <button style="background-color: #eee;width:24px;height:24px;" @click="row.qty++">+</button> {{ row.qty == 1 ? $t('barcode.generator.label') : $t('barcode.generator.labels') }}
                  </v-list-tile-sub-title> -->
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-menu offset-y>
                    <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                    <v-list dense>
                      <!-- <v-list-tile @click="fn_previewItem(index)">
                        <v-list-tile-title>{{ $t('barcode.generator.preview') }}</v-list-tile-title>
                      </v-list-tile> -->
                      <v-list-tile @click="fn_editItem(index)">
                        <v-list-tile-title>Edit</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="fn_removeItem(index)">
                        <v-list-tile-title>Remove</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <!-- <v-btn icon small @click="fn_removeItem(index)">
                    <v-icon small color="error">remove_circle_outline</v-icon>
                  </v-btn> -->
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index < Form.items.length - 1" :key="'div-' + index"></v-divider>
            </template>
          </v-list>

          <div v-if="Form.selectedTemplate && Form.selectedTemplate.printerType === 'Regular' && Form.items.length" class="sheet-note">
            {{ sheetCols }} × {{ sheetRows }} per {{ sheet.paperSize }} page
            · {{ sheetPages.length }} {{sheetPages.length == 1 ? 'page' : 'pages'}}
            <span v-if="sheetCapped" class="cap-note">— capped at {{ sheetMaxCells }}</span>
          </div>
        </v-card>

        <div class="footer-spacer"></div>
      </div>
      
      <!-- 8 — preview / print -->
      <v-footer class="generator-footer">
        <v-layout row wrap>
          <v-flex xs6><v-btn block flat color="primary" :disabled="!canPrint" @click="fn_preview">{{ $t('barcode.generator.preview') }}</v-btn></v-flex>
          <v-flex xs6><v-btn block noshadow color="primary" :disabled="!canPrint" @click="fn_print">Print</v-btn></v-flex>
        </v-layout>
      </v-footer>

      <!-- Label-printer preview: one label per added item -->
      <v-dialog v-model="showPreview" max-width="400px" scrollable transition="dialog-bottom-transition" v-if="showPreview">
        <v-card>
          <v-card-title class="pa-0 pl-3">
            <span>{{ $t('barcode.generator.labelPreview') }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="showPreview = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-alert type="info" icon="info_outline" class="pr-0" :value="true" @click="$router.push('/settings/business/labelprintsettings')">
            <span light-opacity-color>{{ $t('barcode.generator.printerLanguage') }}:</span> {{ $root.LabelPrintSettings && $root.LabelPrintSettings.printLanguage ? $root.LabelPrintSettings.printLanguage.toUpperCase() : 'TSPL' }}<br><span light-opacity-color>{{ $t('barcode.generator.connection') }}:</span> {{ $root.LabelPrintSettings && $root.LabelPrintSettings.printerConnectionType == 'usb' ? 'USB'  : 'Bluetooth' }}
            <!-- <v-icon font16>{{$root.LabelPrintSettings && $root.LabelPrintSettings.printerConnectionType == 'usb' ? 'usb'  : 'blue'}}</v-icon> -->
            <v-spacer></v-spacer>
            <span class="primary-color">{{ $t('barcode.generator.changeSettings') }} <v-icon font16 class="primary-color">chevron_right</v-icon></span>
          </v-alert>
          <v-card-text class="preview-container">
            <div class="preview-info" v-if="Form.selectedTemplate">
              {{ Form.selectedTemplate.width }}mm × {{ Form.selectedTemplate.height }}mm
              <span v-if="displayedPreviewLabels.length"> · {{ displayedPreviewLabels.length }} {{ displayedPreviewLabels.length === 1 ? $t('barcode.generator.label') : $t('barcode.generator.labels') }}</span>
            </div>
            <div class="preview-stage" v-if="Form.selectedTemplate">
              <div class="preview-cell" v-for="(lbl, li) in displayedPreviewLabels" :key="'pl-' + li">
                <div class="preview-cell-name" v-if="lbl.name">{{ lbl.name }}</div>
                <!-- Frame reserves the SCALED footprint so labels stack without
                     the gaps a bare transform:scale would leave behind. -->
                <div
                  data-no-translate
                  class="preview-frame"
                  :style="{
                    width: (Form.selectedTemplate.width * previewScale * labelPreviewScale) + 'px',
                    height: (Form.selectedTemplate.height * previewScale * labelPreviewScale) + 'px'
                  }"
                >
                  <div
                    class="preview-label"
                    data-no-translate
                    :style="{
                      width: (Form.selectedTemplate.width * previewScale) + 'px',
                      height: (Form.selectedTemplate.height * previewScale) + 'px',
                      transform: 'scale(' + labelPreviewScale + ')',
                      transformOrigin: 'top left'
                    }"
                  >
                    <div
                      v-for="(field, index) in lbl.fields"
                      :key="'preview-' + li + '-' + index"
                      :style="getPreviewFieldStyle(field)"
                    >
                      <div v-if="field.fieldName === 'Barcode'" class="field-content">
                        <svg :data-barcode-value="field.fieldValue || '123456789'" style="height:100%;width:auto;max-width:100%;display:block;"></svg>
                      </div>
                      <div v-else-if="field.fieldName === 'Image' && field.imageData" class="field-content">
                        <img :src="field.imageData" style="width:100%;height:100%;object-fit:contain;">
                      </div>
                      <div v-else class="field-content"><span>{{ fn_printText(field) }}</span></div>
                    </div>
                  </div>
                </div>

                <v-layout row wrap mt-2 style="width:100%;align-items: center;">
                  <v-flex xs6 sm6 md6 light-opacity-color>
                    {{ $t('barcode.generator.numberOfLabels') }}
                  </v-flex>
                  <v-flex xs6 sm6 md6 right-align>
                    <v-btn small flat class="ma-1" style="min-width:24px;height:24px;background-color: #ddd;border-radius: 5px;" @click="decreaseQty(lbl)">-</v-btn>
                    <input type="number" style="width:36px;border:1px #ddd solid;border-radius: 5px;padding-left: 4px;" v-model="lbl.labelCount" @input="fn_changeLabelCount(lbl)">
                    <v-btn small flat class="ma-1" style="min-width:24px;height:24px;background-color: #ddd;border-radius: 5px;" @click="increaseQty(lbl)">+</v-btn>
                  </v-flex>
                </v-layout>

                <v-divider></v-divider>

              </div>
            </div>

            
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap pb-2>
              <v-flex xs12 sm12 md12 pl-1 pr-1>
                <v-btn color="primary" block outline @click="fn_print"><v-icon color="primary" class="mr-2">print</v-icon> Print</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 pl-1 pr-1 pt-3>
                <v-btn color="primary" block outline @click="fn_editTemplate"><v-icon color="primary" class="mr-2">edit</v-icon> {{ $t('barcode.generator.editTemplate') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Sheet preview (regular printer) -->
      <v-dialog v-model="showSheet" scrollable fullscreen transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-side-icon @click="showSheet = false"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">{{ $t('barcode.generator.sheetPreview') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="fn_print"><v-icon>print</v-icon></v-btn>
          </v-toolbar>

          <!-- Sheet layout: defaults from the template, overridable for this run. -->
          <!-- <sheet-controls :sheet="sheet" :sheet-sizes="sheetSizes"></sheet-controls> -->

          <v-divider></v-divider>
          <v-card-text class="sheet-stage">
            <print-sheet
              data-no-translate
              :sheetPages="sheetPages"
              :sheetStyle="sheetStyle"
              :sheetCellStyle="sheetCellStyle"
              :sheetFieldStyle="sheetFieldStyle"
              :fields="fields"
              :cells="sheetCells"
              :printText="fn_printText"
            ></print-sheet>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogBatchSelection"
        scrollable 
        transition="dialog-bottom-transition"
      >
        <v-list>
          <v-subheader>{{ $t('barcode.generator.selectBatch') }} <v-spacer></v-spacer> <v-btn icon @click="dialogBatchSelection=false"><v-icon>close</v-icon></v-btn></v-subheader>
          <v-divider></v-divider>
          <template v-for="(batch, batchIndex) in productBatches">
            <v-list-tile :key="batchIndex" @click="fn_selectBatch(batch)">
              <v-list-tile-content>
                <v-list-tile-title>Batch Number: {{ batch.batchNumber }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-dialog>

      <!-- Thermal raster source: one label at exactly 1 CSS px per printer dot.
           Off-screen rather than display:none, because dom-to-image cannot
           rasterize a hidden subtree. -->
      <div class="print-stage" aria-hidden="true">
        <div
          id="barcode-label-wrapper"
          :style="{
            width: printWidthDots + 'px',
            height: printHeightDots + 'px',
            position: 'relative',
            background: '#ffffff',
            overflow: 'hidden'
          }"
        >
          <!-- One positioned column per media column; each carries its own feed
               row's item ([] renders a blank trailing column). -->
          <div
            v-for="(colFields, c) in printColumns"
            :key="'thermal-col-' + c"
            :style="{
              position: 'absolute', top: '0px',
              left: (c * columnStepDots) + 'px',
              width: (currentDimension.width * printDotsPerMm) + 'px',
              height: printHeightDots + 'px',
              overflow: 'hidden'
            }"
          >
            <div v-for="(field, index) in colFields" :key="'thermal-' + c + '-' + index" :style="getPrintFieldStyle(field)">
              <div v-if="field.fieldName === 'Barcode'" class="field-content">
                <svg :data-barcode-value="field.fieldValue || '123456789'" style="height:100%;width:auto;max-width:100%;display:block;"></svg>
              </div>
              <div v-else-if="field.fieldName === 'Image' && field.imageData" class="field-content">
                <img :src="field.imageData" style="width:100%;height:100%;object-fit:contain;">
              </div>
              <div v-else class="field-content"><span>{{ fn_printText(field) }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Regular-printer output. Rendered at printPpm (true mm) so A4 prints as
         A4; App.vue shows #printable and hides #non-printable in @media print. -->
    <div id="printable" v-if="lazerPrintInitiated">
      <print-sheet
        data-no-translate
        :sheetPages="sheetPages"
        :sheetStyle="sheetStyle"
        :sheetCellStyle="sheetCellStyle"
        :sheetFieldStyle="sheetFieldStyle"
        :fields="fields"
        :cells="sheetCells"
        :printText="fn_printText"
        :ppm="printPpm"
        :forPrint="true"
      ></print-sheet>
    </div>

    <dialog-confirmation ref="ref_dialogConfirmation" header="Discard Changes" confirmationMessage="Are you sure you want to discard barcode printing?" :actionMethod="fn_discardBarcodePrint" okBtnText="Yes" cancelBtnText="No"></dialog-confirmation>
  </div>
</template>

<script>
import PrintSheet from './components/print_sheet.vue';
// import SheetControls from './components/sheet_controls.vue';
import barcodeMixin from './barcode_mixin';
import dialogConfirmation from '../dialogs/dialog_confirmation.vue';
const menuItem = require('../../config.js').configs.menuItem;
// import {draftMixin} from '../draft_mixin'

const dialogjs = require('../masters/forms/dialog').dialogjs;


export default {
  name: 'barcode_generator',
  mixins: [barcodeMixin],
  components: {
    'print-sheet': PrintSheet,
    'dialog-confirmation': dialogConfirmation
    // 'sheet-controls': SheetControls
  },

  data() {
    return {
      // Current entry (added to `items` on demand)
      Form: {
        itemId: null,
        itemName: null,
        productCode: null,
        product: null,
        qty: null,
        promptValues: {}, // { [promptId]: value } for the template's Date/Input Text fields
        selectedTemplateId: null,
        selectedTemplate:null,
        items: []
      },

      // Form.selectedTemplate:null,

      // Open state for each date prompt's picker, keyed by promptId.
      promptMenus: {},

      // selectedPaperSize: null,
      templates: [],
      templatesLoading: false,
      // selectedTemplateId: null,

      printerType: 'Label', // 'label' (thermal) | 'regular' (A4 sheet)
      // items: [],
      previewOnly: null, // preview dialog: null = all items, or a single item index

      // Bluetooth label printer. null means "let the native side use the
      // default printer", which is what the designer does today. The mixin's
      // fn_enableBluetooth -> fn_getDefaultPrinter -> fn_connectDevice chain
      // populates this when an explicit device is picked.
      printerAddress: null,

      formId: null,
      productBatches:null,
      dialogBatchSelection:false,
      // draftStorageId:null,
      dialogStorageId:null,
      unwatch:false,
      isGoBack:false,
      directPrint:false
    };
  },

  computed: {
    // Form.selectedTemplate() {
    //   if (!this.selectedTemplateId) return null;
    //   return this.templates.find(t => t.barcodeTemplateId === this.selectedTemplateId) || null;
    // },

    totalLabels() {
      // return this.Form.items.reduce((sum, row) => sum + (row.qty > 0 ? row.qty : 0), 0);
      let sum = 0;
      for(let i=0; i<this.Form.items.length; i++){
        sum = Number(sum + this.Form.items[i].qty);
      }
      return sum;
    },

    canAddItem() {
      return !!(this.Form.itemId && this.Form.product && this.Form.qty > 0 && this.Form.selectedTemplate);
    },

    canPrint() {
      return !!(this.Form.items.length && this.Form.selectedTemplate);
    },

    // The template's Date / Input Text fields, in label reading order (top to
    // bottom), so the generation prompts line up with the label layout.
    promptFields() {
      if (!this.Form.selectedTemplate) return [];
      return this.Form.selectedTemplate.fields
        .filter(f => this.fn_isPromptField(f))
        .slice()
        .sort((a, b) => (a.posTop || 0) - (b.posTop || 0));
    },

    // One entry per physical label, in print order, each carrying that item's
    // own bound values. This is what lets a sheet hold different products.
    sheetCells() {
      if (!this.Form.selectedTemplate) return [];
      const cells = [];
      this.Form.items.forEach(row => {
        const bound = this.fn_bindLabel(this.Form.selectedTemplate.fields, row.product, row.productCode, row.promptValues);
        for (let i = 0; i < row.qty; i++) cells.push(bound);
      });
      return cells;
    },

    // One label per added item (not per copy) for the label-printer preview, so
    // the user can eyeball every item's design at once. Falls back to the
    // current form entry when nothing has been added yet.
    previewLabels() {
      const tpl = this.Form.selectedTemplate;
      if (!tpl) return [];
      const rows = this.Form.items.length ? this.Form.items : (this.Form.itemId ? [this.Form] : []);
      return rows.map(row => ({
        name: row.itemName || '',
        tempLabelId: row.tempLabelId,
        labelCount: row.qty,
        fields: this.fn_bindLabel(tpl.fields, row.product, row.productCode, row.promptValues)
      }));
    },

    // What the preview dialog renders: all items, or just one when previewing a
    // single row (previewOnly holds that item's index).
    displayedPreviewLabels() {
      if (this.previewOnly == null) return this.previewLabels;
      const one = this.previewLabels[this.previewOnly];
      return one ? [one] : this.previewLabels;
    },

    filteredTemplates(){
      return this.templates.filter(t=>t.printerType === this.printerType);
    }
  },

  watch: {
    // The sheet grid sizes itself from sheetLabelQty; keep it at the real total.
    totalLabels(n) {
      this.sheetLabelQty = n > 0 ? n : null;
    },

    // Editing the Item Code must move the barcode. Watch the string so a manual
    // change re-binds the preview even without re-selecting the product.
    'Form.productCode'() {
      this.fn_refreshLabelFields();
    },

    'Form': {
      handler: function (newVal, oldVal){
          if(!this.unwatch){
            // this.fn_saveDraft(this.Form.name);
            localStorage.setItem('barcode_data', JSON.stringify(this.Form))
          }
          this.unwatch = false;
        },
        deep: true
    }
  },

  methods: {
    // --- Templates --------------------------------------------------------

    // Binds a template's fields to a product, with the entered/stored Item Code
    // (productCode) overriding the product's own. The barcode encodes this code,
    // so what the user types is what's generated; an empty code leaves the
    // template's sample value in place.
    fn_bindLabel(templateFields, product, productCode, promptValues) {
      const effective = product ? Object.assign({}, product) : {};
      effective.productCode = (productCode == null) ? '' : String(productCode);
      const fields = this.fn_applyProductToFields(templateFields, effective);
      // Prompt fields (Date / Input Text) take the item's entered value; a blank
      // entry hides the field entirely (it's dropped from the rendered list).
      return fields.filter(f => {
        if (!this.fn_isPromptField(f)) return true;
        const v = promptValues ? promptValues[f.promptId] : '';
        if (v === undefined || v === null || String(v).trim() === '') return false;
        f.fieldValue = v; // raw; fn_printText formats dates and applies the caption
        return true;
      });
    },


    // fn_onPaperSizeChange() {
    //   this.selectedTemplateId = null;
    //   this.fields = [];
    //   this.fn_fetchTemplates();
    // },

    fn_fetchTemplates() {
      const self = this;
      this.templates = [];
      this.templatesLoading = true;
      // this.fn_loadTemplates(this.selectedPaperSize, function (list) {
      this.fn_loadTemplates(null, function (list) {
        self.templatesLoading = false;
        self.templates = list;
        // Auto-select when there's only one design for this paper size.
        if (list.length === 1) {
          self.Form.selectedTemplateId = list[0].barcodeTemplateId;
          // self.fn_onTemplateChange();
        }

        if(!self.Form.selectedTemplateId){
          self.Form.selectedTemplateId = 'a7c9e1f3-5d27-4a9e-8b6c-1e3f5a7c9e04';
        }
      });
    },

    fn_onTemplateChange() {
      // this.items = [];
      let self = this;
      this.fn_getTemplate(this.Form.selectedTemplateId, function(template){
        self.Form.selectedTemplate = template;
        // const tpl = self.Form.selectedTemplate;
        if (!template) return;
        // currentDimension drives cell size, thermal dots and the sheet grid.
        self.currentDimension = { width: template.width, height: template.height };
        // Seed the regular-printer sheet layout from the template's saved config;
        // older templates (no config) keep the mixin defaults. Per-run editable.
        if (template.sheetConfig) self.sheet = Object.assign({}, self.sheet, template.sheetConfig);
        // Thermal N-up media (columns + gaps) travels with the template; older
        // templates (no config) keep the 1-up default.
        if (template.mediaConfig) self.media = Object.assign({}, self.media, template.mediaConfig);
        else self.media = { columns: 1, gapXMm: 0, gapYMm: 0 };

        self.fn_initPromptValues();
        self.fn_refreshLabelFields();  
      });
      
      localStorage.setItem('selected_barcode_template', this.Form.selectedTemplateId);
    },

    // Seed a reactive slot for every prompt field so v-model can bind to it,
    // and reset the date-picker menus.
    fn_initPromptValues() {
      const values = {};
      const menus = {};
      this.promptFields.forEach(f => {
        values[f.promptId] = '';
        menus[f.promptId] = false;
      });
      this.Form.promptValues = values;
      this.promptMenus = menus;
    },

    // Text prompt (and clear): set the value, refresh the live preview.
    fn_setPromptValue(id, val) {
      this.$set(this.Form.promptValues, id, val == null ? '' : val);
      this.fn_refreshLabelFields();
    },

    // Date prompt: store the picked date ('yyyy-MM-dd'), close the picker.
    fn_onPromptDate(id, val) {
      this.$set(this.Form.promptValues, id, val || '');
      this.$set(this.promptMenus, id, false);
      this.fn_refreshLabelFields();
    },

    // `fields` is what the thermal stage and the single-label preview render.
    // Bind it to the first listed item, else the current form entry, so those
    // surfaces show real data — including a manually typed Item Code.
    fn_refreshLabelFields() {
      const tpl = this.Form.selectedTemplate;
      if (!tpl) { this.fields = []; return; }
      const src = this.Form.items.length ? this.Form.items[0] : this.Form;
      this.fields = this.fn_bindLabel(tpl.fields, src.product, src.productCode, src.promptValues);
    },

    // --- Item selection (same dialog pattern as the rest of the app) -------

    fn_openProductsDialog: function () {
      this.fn_openProductList('android', 'ProductList', 'ref_fieldProductName');
    },

    fn_openProductList: function (platform, name, ref) {
      const tagId = this.guidWeb();

      const dialogObj = {};
      dialogObj.tagId = tagId;
      dialogObj.formId = this.formId;
      dialogObj.name = name;
      dialogObj.ref = ref;
      dialogObj.platform = platform;

      const viewDialogObject = {};
      viewDialogObject.ToolbarTitle = "Select Item";
      viewDialogObject.groupTypeId = 101;
      viewDialogObject.TopMenu = [menuItem.new];
      viewDialogObject.isBottomMenu = false;
      viewDialogObject.hideChip = true;
      viewDialogObject.inventory = 1;

      const paramObject = {};
      paramObject.defaultValue = { "id": null, "name": null };
      if (this.Form.itemId && this.Form.itemName) {
        paramObject.defaultValue = { "id": this.Form.itemId, "name": this.Form.itemName };
      }

      dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
    },

    fn_onChange: function (tagId, ref, selectedValueId, selectedValueName, isRemoved) {
      this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
    },

    fn_menuItemClick: function(tagId, menuId, menuAction){
      // tagId id form future use
      // menuId id form future use

      this.fn_closeDialog();
      this.backButtonPress = false;
      
      if(menuAction=='new'){
        this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1}})
      }
      else if(menuAction=='reset'){
        this.fn_resetForm();
      }
    },

    fn_setNewItem: function(){
      if(localStorage.getItem('newItem')){

        let itemData = JSON.parse(localStorage.getItem('newItem'));

        switch (itemData.type) {
          case "product":
              this.fn_updateProduct(itemData.id, itemData.name, false);
                break;
            default:
              console.log("condition not matched");
        }

        localStorage.removeItem('newItem');
      }
    },

    fn_closeDialog: function(){
      dialogjs.fn_checkAndCloseOpenDialogs(this);
    },

    fn_updateProduct: function (id, name) {
      this.Form.itemId = id;
      this.Form.itemName = name;
      this.Form.productCode = null;
      this.Form.product = null;
      if (id) this.fn_getProductData(id);
      this.$forceUpdate();
    },

    fn_getProductData: function (itemId) {
      const self = this;
      this.getData('Product', itemId,
        {
          onSuccess: function (response) {
            const product = typeof response === 'string' ? JSON.parse(response) : response;
            self.Form.product = product;
            self.Form.productCode = product ? product.productCode : null;
            self.fn_getProductBatches(itemId);
            // Reflect the picked item on the preview surfaces straight away.
            self.fn_refreshLabelFields();
          },
          onError: function (error) {
            console.log(error);
            self.showToast(self.$t('barcode.generator.couldNotLoadItem'));
          }
        }
      );
    },

    fn_getProductBatches: function(itemId){
      let self = this;
      this.getData('GetProductBatchByProductId', itemId, 
        {
          onSuccess: function(response){
            console.log(response);
            self.productBatches = JSON.parse(response);
            if(self.productBatches && self.productBatches.length){
              if(self.productBatches.length == 1){
                self.Form.product.batchData = self.productBatches[0];

                if(self.directPrint){
                  if(self.Form.productCode){
                    self.Form.qty = 1;
                    self.fn_addItem();
                  }
                  else{
                    document.getElementById('product_code').focus();
                  }
                }
                
              }
              else{
                self.fn_openBatchSelection();
              }
            }
            else{
              if(self.directPrint){
                if(self.Form.productCode){
                  self.Form.qty = 1;
                  self.fn_addItem();
                }
                else{
                  document.getElementById('product_code').focus();
                }
              }
            }
          }, 
          onError: function(error){
            console.log(error);
          }
        }
      );
    },

    fn_openBatchSelection: function(){
      this.dialogBatchSelection = true;
    },

    fn_selectBatch: function(batch){
      this.Form.product.batchData = batch;
      this.dialogBatchSelection = false;

      if(this.directPrint){
        if(this.Form.productCode){
          this.Form.qty = 1;
          this.fn_addItem();
        }
        else{
          document.getElementById('product_code').focus();
        }
      }
      
      this.fn_refreshLabelFields();
    },

    // --- List -------------------------------------------------------------

    fn_addItem() {
      if (!this.canAddItem) return;
      let item = {
        itemId: this.Form.itemId,
        itemName: this.Form.itemName,
        productCode: this.Form.productCode,
        product: this.Form.product,
        qty: this.Form.qty,
        promptValues: Object.assign({}, this.Form.promptValues),
        tempLabelId: this.Form.tempLabelId || this.guidWeb()
      };
      let itemIndex = this.Form.items.findIndex(row => row.tempLabelId === item.tempLabelId);
      if (itemIndex > -1) {
        this.$set(this.Form.items, itemIndex, item);
      }
      else{
        item.tempLabelId = this.guidWeb();
        this.Form.items.push(item);
      }
      
      this.fn_resetForm();
      this.fn_refreshLabelFields();

      if(this.directPrint){
        this.$nextTick(()=>{
          this.fn_preview();
        })
      }
    },

    fn_removeItem(index) {
      this.Form.items.splice(index, 1);
      this.fn_refreshLabelFields();
    },

    fn_editItem(index) {
      const item = this.Form.items[index];
      // this.Form = {
      //   itemId: item.itemId,
      //   itemName: item.itemName,
      //   productCode: item.productCode,
      //   product: item.product,
      //   qty: item.qty,
      //   promptValues: Object.assign({}, item.promptValues),
      //   tempLabelId: item.tempLabelId
      // };
      this.Form.itemId = item.itemId;
      this.Form.itemName = item.itemName;
      this.Form.productCode = item.productCode;
      this.Form.product = item.product;
      this.Form.qty = item.qty;
      this.Form.promptValues = Object.assign({}, item.promptValues),
      this.Form.tempLabelId = item.tempLabelId;
      // this.fn_removeItem(index);
    },

    fn_resetForm() {
      // Carry the entered prompt values forward — a run usually shares one set
      // of dates/text, so the next item defaults to the same.
      // const carried = Object.assign({}, this.Form.promptValues);
      // this.Form = { itemId: null, itemName: null, productCode: null, product: null, qty: null, promptValues: {} };
      this.Form.itemId = null;
      this.Form.itemName = null;
      this.Form.productCode = null; 
      this.Form.product = null;
      this.Form.qty = null;
      this.Form.promptValues = {};
    },

    // --- Preview / print --------------------------------------------------

    fn_preview(fields) {
      if (!this.canPrint) return;
      this.fn_refreshLabelFields();
      if (this.Form.selectedTemplate.printerType === 'Regular') {
        this.sheetLabelQty = this.totalLabels;
        this.lazerPrintInitiated = true; // build #printable alongside the preview
        this.showSheet = true;           // mixin watcher draws the barcodes
      } else {
        this.previewOnly = null;         // show every item's label
        this.fn_showPreviewLabels();
      }
    },

    // Preview one specific item from the list (used by the per-row action).
    fn_previewItem(index) {
      if (!this.Form.selectedTemplate || !this.Form.items[index]) return;
      this.previewOnly = index;
      this.fn_showPreviewLabels();
    },

    // Open the label-printer preview and draw the barcodes across every label on
    // the stage. fn_generatePreviewBarcodes targets a single .preview-label, so
    // here we sweep the whole .preview-stage to catch all of them.
    fn_showPreviewLabels() {
      this.showPreview = true;
      this.$nextTick(() => {
        this.fn_drawBarcodesIn('.preview-stage');
        this.fn_setLabelPreviewScale();
        this.directPrint = false;
        this.Form.showPreview = this.showPreview;
        localStorage.setItem('barcode_data', JSON.stringify(this.Form));
      });
    },

    fn_print() {
      if (!this.canPrint) return;
      if (this.Form.selectedTemplate.printerType === 'Regular') {
        this.sheetLabelQty = this.totalLabels;
        this.fn_printSheet();            // mixin: true-mm #printable + androidPrint
      } else {
        // this.fn_printThermal();
        if(this.$root.LabelPrintSettings && this.$root.LabelPrintSettings.printerConnectionType == 'usb'){
          this.fn_printThermal();
        }
        else{
          this.$root.fn_checkLocationPermission(()=>{
            this.fn_enableBluetooth('generator', ()=>{
              this.fn_printThermal();
            });
          });
        }
      }
    },

    // Thermal printing. On single-column media each item is one label design and
    // the printer makes that row's copies. On N-up media the feed carries several
    // labels side by side, so we expand items×qty into a flat list and rasterize
    // one composite per feed-row of `mediaColumns` (sequential fill, blank tail).
    fn_printThermal() {
      const self = this;
      const tpl = this.Form.selectedTemplate;
      if (!tpl || !this.Form.items.length) return;
      if (!this.fn_mediaFitsPrinter()) return;

      this.showLoading('Printing labels...');
      let chain = Promise.resolve();

      if (this.mediaColumns <= 1) {
        // One item per feed; let the printer make the copies (fewer round-trips).
        this.Form.items.forEach(function (row) {
          chain = chain
            .then(function () {
              self.printColumns = [self.fn_bindLabel(tpl.fields, row.product, row.productCode, row.promptValues)];
              return self.fn_rasterizeLabel();
            })
            .then(function (dataUrl) {
              if(self.$root.LabelPrintSettings && self.$root.LabelPrintSettings.printerConnectionType == 'usb'){
                self.fn_checkUsbConnected(dataUrl, row.qty)
              }
              else{
                self.fn_printReceipt(dataUrl, self.printerAddress, row.qty);
              }
              
              // self.fn_printReceipt(dataUrl, self.printerAddress, row.qty);
            });
        });
      } else {
        // sheetCells is already items×qty in print order — chunk into feed-rows.
        const cells = this.sheetCells;
        const step = this.mediaColumns;
        for (let i = 0; i < cells.length; i += step) {
          const rowCells = cells.slice(i, i + step);
          chain = chain
            .then(function () {
              self.printColumns = self.fn_padColumns(rowCells);
              return self.fn_rasterizeLabel();
            })
            .then(function (dataUrl) {
              // self.fn_printReceipt(dataUrl, self.printerAddress, 1);
              if(self.$root.LabelPrintSettings && self.$root.LabelPrintSettings.printerConnectionType == 'usb'){
                self.fn_checkUsbConnected(dataUrl, 1)
              }
              else{
                self.fn_printReceipt(dataUrl, self.printerAddress, 1);
              }
            });
        }
      }

      chain
        .then(function () {
          self.hideLoading();
          // self.showToast('Sent ' + self.totalLabels + ' label(s) to the printer');
          self.fn_refreshLabelFields();
        })
        .catch(function (error) {
          console.error('label printing failed:', error);
          self.hideLoading();
          // self.showToast(self.$t('barcode.generator.couldNotGenerateImage'));
        });
    },

    fn_editTemplate: function(){
      // this.showPreview = false;
      this.$nextTick(()=>{
        this.$router.push({path:"/barcode/designer", query:{tagId:this.guidWeb(), templateId:this.Form.selectedTemplateId}});
      });
    },

    fn_goBack(isDiscard) {
      // if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
      //   // this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
      //   this.fn_closeDialog();
      // }
      if(this.showPreview || this.showSheet || this.dialogBatchSelection){
        this.showPreview = false;
        this.showSheet = false;
        this.dialogBatchSelection = false;
      }
      // else if((this.Form.items && this.Form.items.length) || this.Form.selectedTemplateId || this.Form.itemName || this.Form.productCode){
      //   this.fn_openDialogConfirmation();
      // }
      // else{
      // else if(!isDiscard && ((this.Form.items && this.Form.items.length) || this.Form.selectedTemplateId || this.Form.itemName || this.Form.productCode)){
      //   this.fn_openDialogConfirmation();
      // }
      else{
        this.backButtonPress = true;
        this.$router.go(-1);
      }

      // if(isDiscard){
      //   this.backButtonPress = true;
      //   this.$router.go(-1);
      // }
      // }
    },

    fn_discardBarcodePrint: function(){
      this.fn_closeDialog();
      this.$nextTick(()=>{
        this.fn_goBack(1);
      })
    },

    fn_openDialogConfirmation: function(){
      this.fn_openDialogWeb('web', 'Confirmation', 'ref_dialogConfirmation')
    },

    increaseQty: function(lbl){
      let itemIndex = this.Form.items.findIndex(item=>{return item.tempLabelId == lbl.tempLabelId});
      this.Form.items[itemIndex].qty++;
      lbl.labelCount = Number(this.Form.items[itemIndex].qty);
    },

    decreaseQty: function(lbl){
      let itemIndex = this.Form.items.findIndex(item=>{return item.tempLabelId == lbl.tempLabelId});
      this.Form.items[itemIndex].qty > 1 ? this.Form.items[itemIndex].qty-- : '';
      lbl.labelCount = Number(this.Form.items[itemIndex].qty);
    },

    // getLabelQty: function(labelId){
    //   let itemIndex = this.Form.items.findIndex(item=>{return item.tempLabelId == labelId});
    //   return this.Form.items[itemIndex].qty;
    // },

    fn_changeLabelCount: function(lbl){
      let itemIndex = this.Form.items.findIndex(item=>{return item.tempLabelId == lbl.tempLabelId});
      this.Form.items[itemIndex].qty = Number(lbl.labelCount);
    },

    fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

    fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Print Barcode";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},
  },

  mounted() {
    window.js_globals.fn_onBackPress = this.fn_goBack;
    window.js_globals.fn_closeClick = this.fn_closeDialog;

    if (this.$route.query && this.$route.query.tagId) { 
      this.formId = this.$route.query.tagId;
    } else if (this.$route.params && this.$route.params.tagId) {
      this.formId = this.$route.params.tagId;
    }

    // this.draftStorageId = 'cache_'+this.formId;
    this.dialogStorageId = 'dialog_'+this.formId;
    this.unwatch = true;

    // commented printer type as for now only enabling for Label printer
    // Regular A4 printer code is also ready so do not remove this
    let self = this;
    this.$root.fn_getLocalData('printerType', function(response){
      if(!response || response === 'null'){
        console.log('printer type not selected');
      }
      else{
        let typeObj = JSON.parse(response);
        self.printerType = typeObj.printerType;
        self.printerType = 'Label';
      }
      self.fn_fetchTemplates();
    })

    setTimeout(function(){self.fn_setNewItem()},300);

    // if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
    //   this.fn_setFormDataFromDraft(function(draft){
    //     if(draft){
    //       self.Form = JSON.parse(draft.formData);
    //     }
    //   });
    // }

    // this.selectedPaperSize = this.paperSizes.length ? this.paperSizes[0] : null;
    // this.fn_fetchTemplates();
  },
  beforeRouteEnter (to, from, next) {
      next(vm => {
        if(localStorage.getItem('barcode_data')){
          if(from.name === 'barcodeDesigner' || from.name === 'newProduct' || from.name === 'bluetoothDevices' || from.name === 'labelPrintSettings'){
            vm.Form = JSON.parse(localStorage.getItem('barcode_data'));
            vm.Form.showPreview ? vm.fn_preview() : '';
          }
          else{
            localStorage.removeItem('barcode_data');
          }
        }

        if(from.name === 'productDisplay' || from.name === 'labelPrintSettings' || from.name === 'bluetoothDevices' || from.name === 'labelPrintSettings'){
          if(localStorage.getItem('selected_barcode_template') && !vm.Form.selectedTemplateId){
            vm.Form.selectedTemplateId = localStorage.getItem('selected_barcode_template');
          }
          // else{
          //   vm.Form.selectedTemplateId = 'a7c9e1f3-5d27-4a9e-8b6c-1e3f5a7c9e04';
          // }
          !vm.Form.selectedTemplateId ? vm.Form.selectedTemplateId = 'a7c9e1f3-5d27-4a9e-8b6c-1e3f5a7c9e04' : '';

          if(from.name === 'productDisplay'){
            vm.directPrint = true;
            if(vm.$route.query.itemId && vm.$route.query.itemName && !vm.Form.itemId && !vm.Form.itemName){
              vm.fn_updateProduct(vm.$route.query.itemId, vm.$route.query.itemName);
            }
          }
          
        }
      })
  },
  beforeRouteLeave (to, from, next) {
    var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
    if(dialogData && dialogData.length){
      if(this.backButtonPress){
        dialogjs.fn_checkAndCloseOpenDialogs(this);
        next(false);
      }
      else{
        next(true);
      }
    }
    else{
      // if(this.showPreview || this.showSheet || this.dialogBatchSelection){
      //   this.showPreview = false;
      //   this.showSheet = false;
      //   this.dialogBatchSelection = false;
      //   next(false);
      // }
      // else{
        const s = document.getElementById('sheet-print-page-size');
        if (s) s.remove();
        next(true);
      // }
    }
    
  }
};
</script>

<style scoped>
.barcode-generator {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.generator-toolbar {
  background: linear-gradient(to right, #1976d2, #1565c0) !important;
}

/* .generator-body {
  padding: 8px;
  margin-top: 64px;
} */

.template-meta {
  font-size: 12px;
  color: #666;
  padding: 6px 8px;
  background-color: #f0f7ff;
  border-left: 3px solid #2196f3;
  border-radius: 2px;
}

.template-meta-warn {
  background-color: #fff8e1;
  border-left-color: #ffa000;
  color: #8a6d3b;
}

.total-labels {
  font-size: 13px;
  color: #1976d2;
  font-weight: bold;
}

.no-items {
  padding: 24px 16px;
  text-align: center;
  color: #999;
}

.sheet-note {
  padding: 8px 16px;
  font-size: 12px;
  color: #555;
  border-top: 1px solid #eee;
}

.cap-note {
  color: #e65100;
}

.footer-spacer {
  height: 56px;
}

.generator-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-top: 1px solid #ddd;
  height: 48px !important;
  padding: 0;
}

.generator-footer >>> .v-btn {
  height: 48px;
  margin: 0;
}

/* Thermal raster source: off screen but laid out, so dom-to-image can read it. */
.print-stage {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 0;
  height: 0;
  overflow: visible;
  pointer-events: none;
  z-index: -1;
}

.field-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background-color: #fafafa;
}

.preview-info {
  margin-bottom: 16px;
  padding: 6px 12px;
  background-color: #e3f2fd;
  border-radius: 4px;
  font-size: 13px;
  color: #1976d2;
}

.preview-stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.preview-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  max-width: 100%;
}

.preview-cell-name {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  text-align: center;
  max-width: 100%;
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
}

/* Reserves the scaled label footprint so stacked labels sit flush. */
.preview-frame {
  position: relative;
  overflow: hidden;
}

.preview-label {
  position: relative;
  background-color: #ffffff;
  border: 1px solid #999;
  overflow: hidden;
  /* border-box so the 1px border sits inside the scaled width and the frame
     (overflow:hidden) doesn't clip the label's right/bottom edge. */
  box-sizing: border-box;
  /* transform:scale(0.3); */
}

.sheet-stage {
  background: #e9e9e9;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* padding: 24px; */
  gap: 16px;
  padding: 16px;
  overflow: auto;
}

.sheet-stage >>> .sheet-page {
  flex: none;
  margin-bottom: 16px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .25);
}
</style>



// WEBPACK FOOTER //
// src/components/barcode/barcode_generator.vue